/* Card designer, one-page layout.
 *
 * mb-design.js builds a preview of the card plus, underneath it, a separate
 * box per photo with its own little cropper. Two pictures of the same photo,
 * one of which you drag while watching the other, is what made it feel
 * glitchy on a phone.
 *
 * This layer leaves mb-design.js untouched and rearranges what it built:
 * each photo box is lifted onto the card itself, sized and placed exactly
 * over its slot. The cropper inside it is made invisible but still takes the
 * drags, so the customer taps the card to choose a photo and drags the photo
 * on the card to move it. Pinch zooms it. The slider stays below as a
 * fallback.
 *
 * Every listener mb-design.js attached travels with the elements when they
 * are moved, so the file picker, drag, zoom, remove and the print file all
 * keep working exactly as before. If anything is missing it does nothing.
 */
(function () {
  'use strict';

  var wrap = document.querySelector('.mbd');
  var cfg = document.querySelector('[data-mb-design-json]');
  if (!wrap || !cfg) return;

  var T;
  try { T = JSON.parse(cfg.textContent); } catch (e) { return; }
  if (!T || !T.slots || !T.slots.length) return;

  var pv = wrap.querySelector('.mbd__pv');
  var cv = wrap.querySelector('.mbd__cv');
  var boxes = wrap.querySelectorAll('.mbd__slot');
  if (!pv || !cv || boxes.length !== T.slots.length) return;

  /* The card: the canvas plus the slots laid over it, in one positioned box
     the same size as the canvas. */
  var card = document.createElement('div');
  card.className = 'mbd1__card';
  cv.parentNode.insertBefore(card, cv);
  card.appendChild(cv);

  var ICON = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<path d="M4 5h11v2H6v10.6l3.3-3.3 2.2 2.2 4.5-4.5L20 16V12h2v8a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1zm3.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zM18 2h2v3h3v2h-3v3h-2V7h-3V5h3z"/></svg>';

  Array.prototype.forEach.call(boxes, function (box, i) {
    var s = T.slots[i];
    var well = box.querySelector('.mbd__well');
    var ph = box.querySelector('.mbd__ph');
    var crop = box.querySelector('.mbd__crop');
    var zoom = box.querySelector('.mbd__zoom');
    var file = box.querySelector('input[type="file"]');
    var ctl = box.querySelector('.mbd__ctl');
    var tip = box.querySelector('.mbd__tip');
    var lab = box.querySelector('.mbd__lab');
    if (!well || !ph || !crop) return;

    /* Lift the photo box onto the card, over its slot. */
    well.classList.add('mbd1__slot');
    well.style.left = (s.x * 100) + '%';
    well.style.top = (s.y * 100) + '%';
    well.style.width = (s.w * 100) + '%';
    well.style.height = (s.h * 100) + '%';
    card.appendChild(well);

    ph.innerHTML = '<span class="mbd1__btn">' + ICON + '</span>' +
      '<span class="mbd1__cta">' + (T.slots.length > 1
        ? (s.label || 'Add photo ' + (i + 1)) : 'Tap to add your photo') + '</span>';

    box.classList.add('mbd1__below');
    if (lab) lab.style.display = 'none';
    if (tip) tip.textContent = 'Drag the photo to move it. Pinch or use the slider to zoom.';

    /* "Change photo" opens the picker straight away, rather than the
       customer having to remove the photo and then find the box again. */
    if (ctl && file) {
      var chg = document.createElement('button');
      chg.type = 'button';
      chg.className = 'mbd1__change';
      chg.textContent = 'Change photo';
      chg.addEventListener('click', function (e) {
        e.preventDefault();
        file.click();
      });
      ctl.insertBefore(chg, ctl.firstChild);
    }

    /* Pinch to zoom. Two fingers on the photo drive the same slider the
       designer already listens to, so zoom stays in one place. */
    if (zoom) {
      var pts = {}, start = null;
      var count = function () { return Object.keys(pts).length; };
      var gap = function () {
        var k = Object.keys(pts);
        var a = pts[k[0]], b = pts[k[1]];
        return Math.hypot(a.x - b.x, a.y - b.y) || 1;
      };
      crop.addEventListener('pointerdown', function (e) {
        pts[e.pointerId] = { x: e.clientX, y: e.clientY };
        if (count() === 2) start = { d: gap(), z: parseFloat(zoom.value) || 1 };
      });
      crop.addEventListener('pointermove', function (e) {
        if (!pts[e.pointerId]) return;
        pts[e.pointerId] = { x: e.clientX, y: e.clientY };
        if (count() !== 2 || !start) return;
        var z = start.z * (gap() / start.d);
        z = Math.max(parseFloat(zoom.min) || 1, Math.min(parseFloat(zoom.max) || 3, z));
        zoom.value = String(z);
        zoom.dispatchEvent(new Event('input', { bubbles: true }));
      });
      ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) {
        crop.addEventListener(ev, function (e) {
          delete pts[e.pointerId];
          if (count() < 2) start = null;
        });
      });
    }
  });

  wrap.classList.add('mbd1');
  if (wrap.parentNode && wrap.parentNode.id === 'mb-photo') wrap.parentNode.classList.add('mbd1-host');

  /* On the "Your photo" side the flow's own preview box only says "choose a
     photo and it will appear here" - the designer card IS that preview now, so
     the box is hidden while that side is showing. The message side keeps
     its preview. */
  var stage = document.getElementById('mb-stage');
  var faceCard = document.getElementById('mb-face-card');
  var root = document.querySelector('.mb-flow');
  if (root) root.classList.add('mbd1-flow');
  if (stage && faceCard) {
    /* The two sides of the step each show only their own controls: the
       front shows the photo frame, the inside shows the message card with
       its font and colour. Classes on the flow root drive that from CSS. */
    var syncStage = function () {
      var isCard = faceCard.classList.contains('is-on');
      stage.classList.toggle('mbd1-stage-off', isCard);
      if (root) {
        root.classList.toggle('mbd1-face-card', isCard);
        root.classList.toggle('mbd1-face-msg', !isCard);
      }
    };
    var flip = faceCard.parentNode;
    flip.addEventListener('click', function () { setTimeout(syncStage, 0); });
    if (window.MutationObserver) {
      new MutationObserver(syncStage).observe(faceCard, { attributes: true, attributeFilter: ['class'] });
    }
    syncStage();

    /* Photo cards lead with the front: open on the photo side until a photo
       is in. */
    var empty = function () { return !!card.querySelector('.mbd1__slot:not(.is-set)'); };
    if (empty() && !faceCard.classList.contains('is-on')) faceCard.click();

    var faceMsg = document.querySelector('.mb-flip [data-face="msg"]');
    var s4 = document.querySelector('.mb-screen[data-step="4"]');
    var onS4 = function () { return !!(s4 && s4.classList.contains('is-on')); };
    var msgEmpty = function () {
      var ta = document.getElementById('mb-msg');
      var bl = document.getElementById('mb-blank');
      return !(ta && ta.value.trim()) && !(bl && bl.checked);
    };

    /* Turning the card over: a short slide in the direction of travel, so
       front and inside read as two sides of one card. */
    var turn = function (toMsg) {
      var btn = toMsg ? faceMsg : faceCard;
      if (!btn || btn.classList.contains('is-on')) return;
      btn.click();
      if (root) {
        root.classList.remove('mbd1-in-l', 'mbd1-in-r');
        void root.offsetWidth;
        root.classList.add(toMsg ? 'mbd1-in-r' : 'mbd1-in-l');
        setTimeout(function () { root.classList.remove('mbd1-in-l', 'mbd1-in-r'); }, 320);
      }
      fit();
    };

    /* Continue walks the card: front (photo) -> inside (message) -> next
       step. On the front with the frame empty it shows the front so the
       designer's "add your photo" note is visible; with a photo in and no
       message yet it turns the card over instead of raising the "add a
       message" warning. Window capture runs before the designer's and the
       flow's own handlers; it only stops them when it turns the card. */
    window.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('#mb-next');
      if (!btn || !onS4()) return;
      var onFront = faceCard.classList.contains('is-on');
      if (empty()) {
        if (!onFront) turn(false);
        return;
      }
      if (onFront && msgEmpty() && faceMsg) {
        e.preventDefault();
        e.stopPropagation();
        turn(true);
      }
    }, true);

    /* Swipe across the card to turn it over. Ignored when the finger starts
       on the photo (that is a drag), on the controls, or while typing. */
    if (s4) {
      var sx = null, sy = null;
      s4.addEventListener('touchstart', function (e) {
        var t = e.target;
        if (e.touches.length !== 1 ||
            (t.closest && t.closest('.mbd1__slot.is-set, .mbd__ctl, input, select, textarea, [contenteditable]:focus, .mb-fold, button'))) {
          sx = null; return;
        }
        sx = e.touches[0].clientX; sy = e.touches[0].clientY;
      }, { passive: true });
      s4.addEventListener('touchend', function (e) {
        if (sx == null) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        sx = null;
        if (Math.abs(dx) < 60 || Math.abs(dy) > 50) return;
        turn(dx < 0);
      }, { passive: true });
    }
  }

  /* ---- message tools ------------------------------------------------------
     A row of icon buttons over the inside of the card, like a card editor:
     Font, Colour, Help me write, Leave blank. Font and Colour open the flow's
     own pickers in a sheet that slides up over the price bar; Help and Leave
     blank press the flow's own controls. Nothing is copied - the pickers are
     moved, and the flow keeps rendering into them by id. */
  var tools = null, sheet = null;
  (function messageTools() {
    var s4t = document.querySelector('.mb-screen[data-step="4"]');
    if (!s4t || !stage || !root) return;
    var folds = s4t.querySelector('.mb-style2');
    var ff = document.getElementById('mb-fold-font');
    var fc = document.getElementById('mb-fold-col');
    var blank = document.getElementById('mb-blank');
    var help = s4t.querySelector('.mb-helpbtn');
    if (!folds || !ff || !fc) return;

    var I = {
      font: '<svg viewBox="0 0 28 28" aria-hidden="true"><text x="3" y="21" font-family="Georgia,serif" font-size="17" font-weight="700" fill="currentColor">Aa</text></svg>',
      col: '<svg viewBox="0 0 28 28" aria-hidden="true"><circle cx="14" cy="14" r="10" fill="none" stroke="currentColor" stroke-width="2.2"/><circle cx="10" cy="11" r="2.2" fill="#ED217A"/><circle cx="16" cy="9.5" r="2.2" fill="#4FB3BF"/><circle cx="19" cy="15" r="2.2" fill="#F4B942"/><circle cx="11" cy="17" r="2.2" fill="#7FC3A9"/></svg>',
      help: '<svg viewBox="0 0 28 28" aria-hidden="true"><path d="M13 3l2.2 6.3L21.5 11l-6.3 2.2L13 19.5l-2.2-6.3L4.5 11l6.3-1.7z" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><path d="M21 17l1 2.6 2.6 1-2.6 1L21 24l-1-2.4-2.6-1 2.6-1z" fill="currentColor"/></svg>',
      blank: '<svg viewBox="0 0 28 28" aria-hidden="true"><rect x="6" y="3.5" width="16" height="21" rx="2.5" fill="none" stroke="currentColor" stroke-width="2.2"/><path d="M4 24L24 4" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>'
    };

    tools = document.createElement('div');
    tools.className = 'mbd1-tools';
    tools.setAttribute('role', 'toolbar');
    tools.setAttribute('aria-label', 'Message tools');
    var mk = function (key, label) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mbd1-tool';
      b.setAttribute('data-tool', key);
      b.innerHTML = I[key] + '<span>' + label + '</span>';
      tools.appendChild(b);
      return b;
    };
    var bFont = mk('font', 'Font');
    var bCol = mk('col', 'Colour');
    var bHelp = help ? mk('help', 'Help me write') : null;
    var bBlank = blank ? mk('blank', 'Leave blank') : null;
    stage.parentNode.insertBefore(tools, stage);

    sheet = document.createElement('div');
    sheet.className = 'mbd1-sheet';
    sheet.hidden = true;
    var head = document.createElement('div');
    head.className = 'mbd1-sheet__h';
    var title = document.createElement('b');
    var done = document.createElement('button');
    done.type = 'button';
    done.className = 'mbd1-sheet__done';
    done.textContent = 'Done';
    head.appendChild(title); head.appendChild(done);
    sheet.appendChild(head);
    sheet.appendChild(folds);
    root.appendChild(sheet);

    var open = function (which) {
      var isFont = which === 'font';
      title.textContent = isFont ? 'Choose a font' : 'Choose a colour';
      ff.open = isFont; fc.open = !isFont;
      sheet.setAttribute('data-show', which);
      sheet.hidden = false;
      bFont.classList.toggle('is-on', isFont);
      bCol.classList.toggle('is-on', !isFont);
    };
    var close = function () {
      sheet.hidden = true;
      bFont.classList.remove('is-on'); bCol.classList.remove('is-on');
    };
    bFont.addEventListener('click', function () {
      sheet.hidden || sheet.getAttribute('data-show') !== 'font' ? open('font') : close();
    });
    bCol.addEventListener('click', function () {
      sheet.hidden || sheet.getAttribute('data-show') !== 'col' ? open('col') : close();
    });
    done.addEventListener('click', close);
    if (bHelp) bHelp.addEventListener('click', function () { close(); help.click(); });
    if (bBlank) {
      var syncBlank = function () {
        bBlank.classList.toggle('is-on', blank.checked);
        bBlank.setAttribute('aria-pressed', blank.checked ? 'true' : 'false');
      };
      bBlank.addEventListener('click', function () { close(); blank.click(); syncBlank(); });
      blank.addEventListener('change', syncBlank);
      syncBlank();
    }
    /* The sheet belongs to the inside of the card only. */
    if (faceCard) faceCard.addEventListener('click', close);
  })();

  /* ---- page strip ---------------------------------------------------------
     Thumbnails of the two sides under the card, like a card editor: the
     front (a live copy of the designer card) and the inside (the message).
     Tapping one turns the card over; the arrows do the same. It replaces the
     tabs at the top, which stay in the page, hidden, as the flow's own
     switch. */
  var strip = null, thumbFront = null, thumbIn = null;
  (function pageStrip() {
    var col = document.getElementById('mb-photo');
    if (!col || !col.parentNode || !faceCard || typeof turn !== 'function') return;
    strip = document.createElement('div');
    strip.className = 'mbd1-strip';
    strip.innerHTML =
      '<button type="button" class="mbd1-strip__arw" data-go="front" aria-label="Show the front">&#8249;</button>' +
      '<button type="button" class="mbd1-strip__pg" data-go="front"><canvas class="mbd1-strip__cv" width="120" height="170"></canvas><span>Front</span></button>' +
      '<button type="button" class="mbd1-strip__pg" data-go="inside"><span class="mbd1-strip__in"><i></i></span><span>Inside</span></button>' +
      '<button type="button" class="mbd1-strip__arw" data-go="inside" aria-label="Show the inside">&#8250;</button>';
    col.parentNode.appendChild(strip);
    thumbFront = strip.querySelector('.mbd1-strip__cv');
    thumbIn = strip.querySelector('.mbd1-strip__in i');

    strip.addEventListener('click', function (e) {
      var b = e.target.closest('[data-go]');
      if (b) turn(b.getAttribute('data-go') === 'inside');
    });

    var drawFront = function () {
      try {
        var c = thumbFront.getContext('2d');
        c.clearRect(0, 0, thumbFront.width, thumbFront.height);
        c.drawImage(cv, 0, 0, thumbFront.width, thumbFront.height);
      } catch (e) { /* a not-yet-drawn canvas is fine to skip */ }
    };
    var drawIn = function () {
      var ta = document.getElementById('mb-msg');
      thumbIn.textContent = ta ? ta.value : '';
    };
    var mark = function () {
      var front = faceCard.classList.contains('is-on');
      strip.querySelectorAll('.mbd1-strip__pg').forEach(function (b) {
        var on = (b.getAttribute('data-go') === 'front') === front;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-current', on ? 'page' : 'false');
      });
      drawFront(); drawIn();
    };
    /* Redraw when anything on the card can have changed. */
    ['pointerup', 'input', 'change'].forEach(function (ev) {
      document.addEventListener(ev, function () { setTimeout(function () { drawFront(); drawIn(); }, 80); }, true);
    });
    if (window.MutationObserver) {
      new MutationObserver(mark).observe(faceCard, { attributes: true, attributeFilter: ['class'] });
    }
    setTimeout(mark, 400);
    setTimeout(drawFront, 1500);
  })();

  /* Fit the card to the screen: as big as it can be with the step heading
     above and the price bar below still in view, so neither side needs
     scrolling. */
  function fit() {
    var bar = parseFloat(getComputedStyle(document.documentElement)
      .getPropertyValue('--mb-flow-bar-height')) || 150;
    /* Space above the card inside the step (tabs etc.), measured when the
       step is showing; a fair guess when it is not. The zoom row under the
       front takes about 60px. */
    var head = 260;
    var s4el = document.querySelector('.mb-screen[data-step="4"]');
    if (s4el && s4el.classList.contains('is-on')) {
      var host = faceCard && faceCard.classList.contains('is-on') ? card : stage;
      var a = host && host.getBoundingClientRect();
      /* Where the card actually starts on screen, once the step has scrolled
         into place - that includes the progress header above the step, which
         measuring from the step's own top missed. */
      if (a && a.height && a.top > 0 && a.top < window.innerHeight * 0.6) head = a.top + 16;
    }
    var avail = window.innerHeight - bar - head - 60 - (strip ? 96 : 0);
    var h = Math.max(300, avail);
    var w = Math.floor(h * (T.print_w / T.print_h));
    card.style.maxWidth = Math.min(420, w) + 'px';
    /* The inside of the card is drawn the same size and shape as the front,
       so turning it over looks like one card. */
    if (root) root.style.setProperty('--mbd1-card-w', Math.min(420, w) + 'px');
  }
  fit();
  /* Re-fit when step 4 comes into view - it is measured, not guessed. */
  var s4w = document.querySelector('.mb-screen[data-step="4"]');
  if (s4w && window.MutationObserver) {
    new MutationObserver(function () {
      if (s4w.classList.contains('is-on')) { setTimeout(fit, 60); setTimeout(fit, 700); }
    }).observe(s4w, { attributes: true, attributeFilter: ['class'] });
  }
  var fz;
  window.addEventListener('resize', function () {
    if (fz) clearTimeout(fz);
    fz = setTimeout(fit, 120);
  });

  /* Writing the message. While the card is being typed on, the chat bubble
     is moved out of the way and the card is brought to the middle of the
     screen so the keyboard does not cover it. */
  if (stage) {
    stage.addEventListener('focusin', function (e) {
      var t = e.target.closest && e.target.closest('.mb-pv__t');
      if (!t) return;
      document.body.classList.add('mbd1-typing');
      setTimeout(function () {
        if (t.scrollIntoView) t.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }, 250);
    });
    stage.addEventListener('focusout', function () {
      document.body.classList.remove('mbd1-typing');
    });
  }

  /* The canvas is now wider on phones, so let the designer redraw at the
     new size. It already listens for resize. */
  window.dispatchEvent(new Event('resize'));
})();
